const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50
  },
  {
    prop: "StatusName",
    label: "状态",
    columnwidth: 80,
  },
  {
    prop: "VouCode",
    label: "经销商出库单号",
    columnwidth: 146,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 90,
  },
  {
    prop: "DPDate",
    label: "出库日期",
    columnwidth: 120,
  },
  {
    prop: "CreateOrgName",
    label: "出库方名称",
    columnwidth: 240,
  },
  {
    prop: "HospitalName",
    label: "仓库名称",
    columnwidth: 210,
  },
  {
    prop: "Remark",
    label: "备注",
    columnwidth: 160,
  },
  {
    prop: "CreatorName",
    label: "创建人",
    columnwidth: 210,
  },
  {
    prop: "CreateTime",
    label: "创建时间",
    columnwidth: 160,
  },
  {
    prop: "VerifierName",
    label: "审核人",
    columnwidth: 210,
  },
  {
    prop: "VerifyTime",
    label: "审核时间",
    columnwidth: 160,
  },
]
export default headerData
